import { useNps } from "@/contexts/Nps/context";
import { Button, CircularProgress, Paper, Table,
  TableBody,
  TableCell,
  TableContainer, 
  TableHead, 
  TablePagination, 
  TableRow, 
  Tooltip
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getButtonColor } from "@/utils/degradeBotoes";
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import { ModalFeedbackComentario } from "../modalFeedbackComentario";
import style from "./style.module.css";
import { formataDataAsHoras } from "@/utils/formatDateTo";
import { safeJsonParse } from "@/utils/safeJsonParse";

export function TabelaFeedback(){
  const {npsAtendimentos, loading, getNpsAtendimentos, getFeedback } = useNps();
  const jwtAtendente = localStorage.getItem("attendant");
  const atendente = jwtAtendente ? safeJsonParse(jwtAtendente) : null;

  const [,setSearchParams] = useSearchParams();
  const [pagina, setPagina] = useState<number>(0);
  const [linhasPorPagina, setLinhasPorPagina] = useState<number>(10);
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const rowBody = npsAtendimentos?.data || [];
  const totalRows: number = npsAtendimentos?.total ?? 0;
  
  useEffect(() => {
    getNpsAtendimentos({ 
      pagina: pagina + 1, 
      tamanhoPagina: linhasPorPagina,
      atendente_id: atendente.id
    });
  }, [pagina, linhasPorPagina, atendente.id])

  const rowHeaders = [
    {id: "id", label: "ID"}, 
    {id: "cliente", label: "Cliente", minWidh: 150}, 
    {id: "nota", label: "Nota"}, 
    {id: "feedback", label: "Feedback"},
    {id: "atendente", label: "Atendente", minWidh: 150},
    {id: "data/Hora", label: "Data/Hora"} 
  ]

  function alterarPagina(event: unknown, newPage: number) {
    setPagina(newPage);
  }

  function alterarQuantidadeLinhasPorPagina(event: React.ChangeEvent<HTMLInputElement>) {
    const value = +event.target.value;
    setLinhasPorPagina(value)
    setPagina(0);

     setSearchParams((params) => {
      params.set("tamanhoPagina", value.toString());
      return params;
    })
  }

  function handleModal(id?: number) {
    setModalOpen((prev) => !prev);
    if(id){
      getFeedback(id)
    }
  }

  return(
    <>
      <Paper>
        <TableContainer
          sx={{
            overflowY: 'auto',
            flexGrow: 1,
            maxHeight: 700,
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                { rowHeaders?.map((item) => {
                  return(
                    <TableCell
                      key={item.id}
                      style={{ 
                        minWidth: item.minWidh || 100,
                        color: 'rgba(76, 78, 100, 0.5)',
                      }}
                    >
                      {item.label}
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              { loading ? 
                <TableRow>
                  <TableCell 
                    colSpan={rowHeaders.length} 
                    sx={{ textAlign: 'center', py: 5 }}
                  >
                    <CircularProgress sx={{color: '#666CFF'}}/>
                  </TableCell>
                </TableRow>
              : rowBody?.map((item) => {
                const notaJornada = item.feedback_avalicacao_recomendacao;
                const notaMontagem = item.feedback_avaliacao_montagem;
                const backgroundColorJornada = notaJornada > 0 ? getButtonColor(notaJornada) : 'white';
                const backgroundColorMontagem = notaMontagem > 0 ? getButtonColor(notaMontagem) : 'white';

                return(
                  <TableRow key={item.id}>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.Cliente.nome}</TableCell>
                    <TableCell>
                      <div className={style.notas_feedback}>
                        <Tooltip title={"Nota da Jornada"}>
                          <span 
                            style={{backgroundColor: backgroundColorJornada}}
                            className={style.valor_avaliacao}
                          >
                            {item.feedback_avalicacao_recomendacao}
                          </span>
                        </Tooltip>
                        <Tooltip title={"Nota de Montagem"}>
                          <span 
                            style={{backgroundColor: backgroundColorMontagem}}
                            className={style.valor_avaliacao}
                          >
                            {item.feedback_avaliacao_montagem}
                          </span>
                        </Tooltip>
                      </div>
                    </TableCell>
                    <TableCell>
                      <Button 
                        onClick={() => handleModal(item.id)}
                        disabled={item.mensagem_feedback ? false : true}
                        className={style.botao_acessar_feedback}
                      >
                        <CommentOutlinedIcon/>
                      </Button>
                    </TableCell>
                    <TableCell>{item.Atendente.nome}</TableCell>
                    <TableCell>{formataDataAsHoras(item.data_envio_feedback)}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 50, 100]}
          component="div"
          count={totalRows}
          rowsPerPage={linhasPorPagina}
          page={pagina}
          onPageChange={alterarPagina}
          onRowsPerPageChange={alterarQuantidadeLinhasPorPagina}
        />
      </Paper>

      <ModalFeedbackComentario
        open={modalOpen}
        onClose={() => handleModal()}
      />
    </>
  )
}